export enum SwEvents {
    NotificationUpdate = 'notificationUpdate'
}
